export default __webpack_public_path__ + "static/portfolio_gallery_22-2227aacd30952710ecf68b39c2feaa7d.jpg";